var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:linkedin",
    clipPath: "url(#clip0_504_43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 1.57575C0 0.705375 0.72325 0 1.61562 0H20.3844C21.2768 0 22 0.705375 22 1.57575V20.4242C22 21.2946 21.2768 22 20.3844 22H1.61562C0.72325 22 0 21.2946 0 20.4242V1.57575ZM6.79662 18.4167V8.48238H3.49525V18.4167H6.79662ZM5.14663 7.12525C6.2975 7.12525 7.01388 6.3635 7.01388 5.40925C6.99325 4.43437 6.29888 3.69325 5.16862 3.69325C4.03837 3.69325 3.3 4.43575 3.3 5.40925C3.3 6.3635 4.01638 7.12525 5.12463 7.12525H5.14663ZM11.8951 18.4167V12.8686C11.8951 12.5716 11.9171 12.2746 12.0051 12.0629C12.243 11.4703 12.7861 10.8556 13.6991 10.8556C14.894 10.8556 15.3711 11.7659 15.3711 13.1024V18.4167H18.6725V12.7188C18.6725 9.66625 17.0445 8.24725 14.872 8.24725C13.1202 8.24725 12.3351 9.20975 11.8951 9.88762V9.922H11.8731C11.8804 9.91052 11.8878 9.89906 11.8951 9.88762V8.48238H8.59513C8.63637 9.41463 8.59513 18.4167 8.59513 18.4167H11.8951Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkin);
export default __webpack_public_path__ + "static/media/linkin.f47d9db088d210d52e7f3fc0e03edfd6.svg";
export { ForwardRef as ReactComponent };